import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import useTheme from "@mui/material/styles/useTheme";

import { neutral } from "app/themes/colors";

import StaffTaskForm from "../components/staff-task-form.component";
import useStaffTasksV2 from "../hooks/use-staff-tasks-v2.hook";
import StaffTasksDrawerContent from "./staff-tasks-drawer-content.component";

export default function StaffTasksV2Drawer() {
  const theme = useTheme();
  const { taskDrawerMode, handleCloseTaskDrawer } = useStaffTasksV2();

  return (
    <Drawer
      PaperProps={{
        sx: {
          width: 410
        }
      }}
      variant="persistent"
      anchor="right"
      open={Boolean(taskDrawerMode)}
      onClose={handleCloseTaskDrawer}
      sx={{
        zIndex: theme.zIndex.snackbar - 100
      }}
    >
      <Box
        display="flex"
        justifyContent="end"
        position="absolute"
        width="100%"
        mt={1}
      >
        <IconButton onClick={handleCloseTaskDrawer}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box height="100%" overflow="auto" sx={{ background: neutral[50] }}>
        {taskDrawerMode === "create" ? (
          <StaffTaskForm />
        ) : (
          <StaffTasksDrawerContent />
        )}
      </Box>
    </Drawer>
  );
}
